import { ROUTES } from '../lib/routes'

export type ToolLink = {
  href: (typeof ROUTES)[keyof typeof ROUTES]
  label: string
  shortLabel: string
  description: string
  popular?: boolean
}

export const TOOL_LINKS: ToolLink[] = [
  // Fila 1: Herramientas principales (mayor demanda)
  {
    href: ROUTES.mergePdf,
    label: 'Combinar PDF',
    shortLabel: 'Combinar',
    description: 'Une varios PDFs en uno solo.',
    popular: true,
  },
  {
    href: ROUTES.compressPdf,
    label: 'Comprimir PDF',
    shortLabel: 'Comprimir',
    description: 'Reduce el tamaño del archivo manteniendo la calidad.',
    popular: true,
  },
  {
    href: ROUTES.signPdf,
    label: 'Firmar PDF',
    shortLabel: 'Firmar',
    description: 'Añade tu firma a cualquier documento PDF.',
    popular: true,
  },
  // Fila 2: Conversiones y División
  {
    href: ROUTES.pdfToJpg,
    label: 'PDF a JPG/PNG',
    shortLabel: 'PDF → Imagen',
    description: 'Exporta páginas como JPG o PNG (ZIP para varias).',
    popular: true,
  },
  {
    href: ROUTES.jpgToPdf,
    label: 'JPG/PNG a PDF',
    shortLabel: 'Imagen → PDF',
    description: 'Convierte imágenes a un PDF; reordena fácilmente.',
  },
  {
    href: ROUTES.splitPdf,
    label: 'Dividir PDF',
    shortLabel: 'Dividir',
    description: 'Divide por rango de páginas o cada página.',
  },
  // Fila 3: Herramientas de utilidad
  {
    href: ROUTES.rotatePdf,
    label: 'Rotar PDF',
    shortLabel: 'Rotar',
    description: 'Rota páginas seleccionadas o todo el archivo.',
  },
  {
    href: ROUTES.deletePdfPages,
    label: 'Eliminar páginas PDF',
    shortLabel: 'Eliminar páginas',
    description: 'Elimina páginas específicas de un PDF.',
  },
]
